import { Injectable } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { timeout } from 'rxjs/operators';
import { BBResponseContainer } from '../common-services/response-container';


@Injectable({
  providedIn: 'root'
})
export class RunplanSchedulerService {
    
    constructor(private http: HttpClient) { }
    
    getSequencerMachines(labName:string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "mdm/machinetype/sequencer";
        let requestParam = new HttpParams().set('labName', labName);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    getFlowcellCapacity(labId: string, sequencer:string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "mdm/flowcell/getCapacity/" + labId + "/" + sequencer;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    getUnscheduledRuns(request: any): Observable<any> {
        let url = environment.BB_NGS_RUN_PLANNING_URL + 'runplan/unscheduledlist';
        return this.http.put<any>(url, request).pipe(timeout(environment.defaultTimeout));
    }
    
    getScheduledRuns(request: any): Observable<any> {
        let url = environment.BB_NGS_RUN_PLANNING_URL + 'runplan/scheduledlist';
        return this.http.put<any>(url, request).pipe(timeout(environment.defaultTimeout));
    }

    unscheduleRun(request: { lab: any; runId: string; puid: string; }) {
      let url = environment.BB_NGS_RUN_PLANNING_URL + 'runplan/unschedule';
        return this.http.patch<any>(url, request).pipe(timeout(environment.defaultTimeout));
    }

    getSchedulePlanToDisplay(lab: string, beginDate: string, endDate: string): Observable<any> {
        let url = environment.BB_NGS_RUN_PLANNING_URL + "runplan/schedulePlan/" + lab + "/" + beginDate + "/" + endDate;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    saveRun(runObj: any): Observable<any> {
        let url = environment.BB_NGS_RUN_PLANNING_URL + 'runplan/scheduleRun';
        return this.http.put<any>(url, runObj).pipe(timeout(environment.defaultTimeout));
    }

    getFlowCellModeType(labId: string, flowCellName:string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + "mdm/flowcell/getFlowCellModeType";
        let requestParam = new HttpParams().set('labId', labId).set('flowCellName', flowCellName);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
}
